import MainLayout from 'components/layout/MainLayout';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import React, { ReactNode } from 'react';
import styles from './V2EnterLayout.module.css';
import EnterFlowFooter from '../EnterFlowFooter';

interface V2EnterLayoutProps {
  mobileTop: ReactNode;
  mobileBottom: ReactNode;
  desktopLeft: ReactNode;
  desktopRight: ReactNode;
}

export const V2EnterLayout: React.FC<V2EnterLayoutProps> = (props) => {
  const { isMobile } = useIsMobile();
  return (
    <MainLayout
      limitItemWidths
      hideHeader
      additionalClassName="daymadeTypographyReset"
    >
      {isMobile ? (
        <div className={styles.mobileContainer}>
          <div className={styles.mobileTop}>{props.mobileTop}</div>
          <div className={styles.mobileBottom}>
            {props.mobileBottom}
            <EnterFlowFooter />
          </div>
        </div>
      ) : (
        <div className={styles.desktopContainer}>
          <div className={styles.desktopLeft}>
            <div className={styles.desktopLeftInner}>{props.desktopLeft}</div>
          </div>
          <div className={styles.desktopRight}>
            <div className={styles.desktopRightInner}>
              {props.desktopRight}
              <div className={styles.desktopRightFooter}>
                <EnterFlowFooter variant="V2" />
              </div>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default V2EnterLayout;
